import React, { useState } from 'react'
import { buildStyles, CircularProgressbar } from 'react-circular-progressbar'
import { FiEdit, FiUsers } from 'react-icons/fi'
import { HiOutlineMinus, HiOutlinePlus } from 'react-icons/hi'
import { RiDeleteBin6Line } from 'react-icons/ri'
import Button from '../../Components/Button'
import QuizHeader from '../../Components/QuizHeader'
import styles from "./Styles/SpaceConfig.module.css"
import spaceConfigImage from "../../Assets/spaceConfigImage.png"
import { useNavigate } from 'react-router-dom'

export default function SpaceConfig() {


  const navigate = useNavigate()
  const [spaceConfig, setSpaceConfig] = useState([{
    name:'Cabins',
    quantity:3
  },
  {
    name:'Open Workspace',
    quantity:5
  },
  {
    name:'Meeting Room',
    quantity:2
  },
  {
    name:'Public Space',
    quantity:1
  },
  {
    name:'Circulation & Support Spaces',
    quantity:6
  }])

  const Card = () => {
    return <div className={styles.spaceConfigCard}>
        <div className={styles.spaceConfigCardImage}>
            <img src={spaceConfigImage} />
        </div>

        <div className={styles.spaceConfigCardContent}>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:16}}>
                <h2>MD CABIN</h2>
                <div style={{display:'flex',alignItems:'center',gap:8}}>
                    <FiUsers size={20} color="#C2CFE0" />
                    <h2>04</h2>
                </div>
            </div>
            <div style={{display:'flex',alignItems:'center',justifyContent:'space-between'}}>
                <h3>Size</h3>
                <h4>L-23 x W-23 x H-24 </h4>
            </div>
            <div className={styles.sqFtBtn}>
                125 Sq ft
            </div>
            <div className={styles.addSubtractBtns}>
                <button><HiOutlineMinus color="#fff" size={22} /></button>
                    <p>03</p>
                <button><HiOutlinePlus color="#fff" size={22} /></button>
            </div>
        </div>
    </div>
}
  
  return (
    <React.Fragment>
      <QuizHeader step4 />

      <div className={styles.container}>
      <header>
          <h2>Configure Your Space</h2>
        </header>


      <div className={styles.spaceConfig}>  

    <div style={{display:'flex',justifyContent:'center',alignItems:'center',gap:16}}>
    <div className={styles.spaceConfigHeader}>
        <h2>Total Area</h2>
        <h3>13370 <span>Sq ft</span></h3>
    </div>
    <div className={styles.spaceConfigHeader}>
        <h2>Total Area Utilised</h2>
        <h3 style={{color:'#4AC2C6'}}>13370 <span>Sq ft</span></h3>
    </div>
    </div>

    <header>
        <div className={styles.legend}>
            <div>
            <div>
                <span style={{backgroundColor:'#FF4906'}}></span>
                <p>Open Workspaces</p>
            </div>
            <p>x24</p>
            </div>
            <div>
            <div>
                <span style={{backgroundColor:'#707ED1'}}></span>
                <p>Cabins</p>
            </div>
            <p>x02</p>
            </div>
            <div>
            <div>
                <span style={{backgroundColor:'#FFB55F'}}></span>
                <p>Meeting Rooms</p>
            </div>
            <p>x03</p>
            </div>
            <div>
            <div>
                <span style={{backgroundColor:'#9C6DFF'}}></span>
                <p>Public Space</p>
            </div>
            <p>x11</p>
            </div>
            <div>
            <div>
                <span style={{backgroundColor:'#FF796C'}}></span>
                <p>Circulation & Support Spaces</p>
            </div>
            <p>x11</p>
            </div>
        </div>
            <div className={styles.separator}></div>
        <div className={styles.totalSeats}>
            <h2>Total Seats</h2>
            <div>
                <FiUsers color="#161C45" size={60} />
                <h3>215</h3>
            </div>
        </div>
            <div className={styles.separator}></div>
        <div>
            pie chart
        </div>
    </header>

    <div className={styles.spaceConfigItems}>

        {spaceConfig.map(i => {
            return <div className={styles.spaceConfigItem}>
            <div className={styles.spaceConfigItemHeader}>
                <div style={{display:'flex',alignItems:'center',gap:16}}>
                    <h2>{i.name}</h2>
                    <h3>x02</h3>
                    <div style={{width:40,height:40}}>
                    <CircularProgressbar value={10} text={`${10}%`}
                        styles={buildStyles({
                        textSize: '28px',
                        pathTransitionDuration: 0.5,
                        textColor: '#41CD70',
                        pathColor:'#41CD70'
                    })}
                     />
                    </div>
                </div>

                <div className={styles.editDelete}>
                    <FiEdit color="#6DB4C4" size={26} />
                    <RiDeleteBin6Line color="#F7685B" size={26} />
                </div>
            </div>

            <div className={styles.spaceConfigCardsContainer}>
                {Array(i.quantity).fill('').map(c => {
                    return <Card />
                })}
            </div>
        </div>
        })}
    </div>
    </div>
        <div style={{display:'flex',justifyContent:'center'}}>
        <Button height={56} width={320} onClickHandler={()=>navigate('/quiz/costpackage')} radius={10} mt={32} title="Continue" />
        </div>
      </div>
      
    </React.Fragment>
  )
}
